import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { BarberShop } from './views/BarberShop';
import { Background } from './components/Background';
import { store } from './redux';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<BarberShop />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.BarberShop)
	.build();

export default Layout;
